// import React, { useEffect } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";

// // Importing images
// import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import img3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

// const Testmonial = () => {
//   // Owl Carousel settings
//   const options = {
//     loop: true,
//     autoplay: false,
//     autoplayTimeout: 3000,
//     smartSpeed: 800,
//     dots: true,
//     nav: false,
//     margin: 20,
//     responsive: {
//       0: { items: 1 },
//       600: { items: 2 },
//       1000: { items: 3 },
//     },
//   };

//   return (
//     <section aria-label="testimony">
//       <div className="container-fluid p-5">
//         <div className="row p-3-vh d-flex justify-content-center">
//           <div className="col-12 centered">
//             <div className="detailcontent text-center p-0">
//               <div className="heading " style={{ color: 'rgb(16 16 14);' }}>
//                 What Our <span style={{ color: '#f7941d' }}>Trainers Say</span>
//               </div>
//             </div>
//           </div>
//           <div className="col-10">
//             <OwlCarousel className="owl-carousel owl-theme" {...options}>
//               {/* Card 1 */}
//               <div className="item">
//                 <div
//                   className="content-testy"
//                   style={{
//                     border: "2px solid #0a8194",
//                     borderTop: "10px solid #0a8194",

//                     padding: "20px",
//                     borderRadius: "10px",

//                   }}
//                 >
//                   <div className="testy-text" style={{ marginTop: "-10px" }}>
//                     <span>
//                       As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications. My career has focused on developing robotic simulations, programming, and integrating advanced tools to design intelligent systems. I ensure that my trainees gain hands-on experience in creating real-world robotic models, preparing them for a future where automation and robotics redefine the industry landscape.
//                     </span>
//                   </div><br />
//                   <div className="user">
//                     <div className="img">
//                       <img src={img1} alt="imgtesty" />
//                     </div>
//                     <div className="name" style={{ textAlign: "center" }}>G. Lokesh</div>
//                     <div
//                       className="title"
//                       style={{
//                         fontSize: "20px",
//                         textAlign: "center",
//                       }}
//                     >
//                       Automation Training Specialist
//                     </div>
//                     <div
//                       className="social-icons"
//                       style={{
//                         marginTop: "18px",
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       {/* Facebook Icon */}
//                       <a
//                         href="#"
//                         className="social-icon facebook"

//                       >
//                         <i className="fab fa-facebook-f" style={{fontSize:'20px'}}></i>
//                       </a>
//                       {/* Twitter Icon */}
//                       <a
//                         href="#"
//                         className="social-icon twitter"
//                       >
//                         <i className="fab fa-twitter" style={{fontSize:'20px'}}></i>
//                       </a>
//                       {/* LinkedIn Icon */}
//                       <a
//                         href="#"
//                         className="social-icon linkedin"
//                       >
//                         <i className="fab fa-linkedin-in" style={{fontSize:'22px'}}></i>
//                       </a>
//                       {/* Instagram Icon */}
//                       <a
//                         href="#"
//                         className="social-icon instagram"
//                       >
//                         <i className="fab fa-instagram" style={{fontSize:'22px'}}></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Card 2 */}
//               <div className="item">
//                 <div className="content-testy" style={{ border: '2px solid #0a8194', padding: '20px', borderRadius: '10px',borderTop: "10px solid #0a8194", }}>
//                   <div className="testy-text" style={{ marginTop: '-10px' }}>
//                     <span>
//                       With 15 years of extensive experience in Tools and Fixture Design, I bring a wealth of knowledge to every training session. My expertise lies in designing innovative tools and fixtures that align with industry standards, improving manufacturing accuracy, and reducing downtime. My sessions are structured to provide insights into problem-solving, 2D layout studies, and quality control measures, ensuring that learners leave with practical skills they can immediately apply in their careers.
//                     </span>
//                   </div><br />
//                   <div className="user">
//                     <div className="img">
//                       <img src={img2} alt="imgtesty" />
//                     </div>
//                     <div className="name" style={{ textAlign: "center" }}>Riyaz Uddin
//                     </div>
//                     <div className="title" style={{ fontSize: '20px', textAlign: "center" }} >Subject Matter Expert
//                     </div>
//                     <div
//                       className="social-icons"
//                       style={{
//                         marginTop: "18px",
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       <a
//                         href="#"
//                         className="social-icon facebook"
//                       >
//                         <i className="fab fa-facebook-f" style={{fontSize:'20px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon twitter"
//                       >
//                         <i className="fab fa-twitter" style={{fontSize:'20px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon linkedin"
//                       >
//                         <i className="fab fa-linkedin-in" style={{fontSize:'22px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon instagram"
//                       >
//                         <i className="fab fa-instagram" style={{fontSize:'22px'}}></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Card 3 */}
//               <div className="item">
//                 <div className="content-testy" style={{ border: '2px solid #0a8194',borderTop: "10px solid #0a8194", padding: '20px', borderRadius: '10px' }}>
//                   <div className="testy-text" style={{ marginTop: '-10px' }}>
//                     <span>
//                       With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational costs. Training with me means diving deep into the core of digital facility design, understanding parametric modeling, and mastering innovative validation techniques.
//                     </span>
//                   </div>
//                   <div className="user">
//                     <div className="img">
//                       <img src={img3} alt="imgtesty" />
//                     </div>
//                     <div className="name" style={{ textAlign: "center" }}>MD. Ghouse
//                     </div>
//                     <div className="title" style={{ fontSize: '20px', textAlign: "center" }} >Technical Trainer
//                     </div>
//                     <div
//                       className="social-icons"
//                       style={{
//                         marginTop: "18px",
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       <a
//                         href="#"
//                         className="social-icon facebook"
//                       >
//                         <i className="fab fa-facebook-f" style={{fontSize:'20px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon twitter"
//                       >
//                         <i className="fab fa-twitter" style={{fontSize:'20px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon linkedin"
//                       >
//                         <i className="fab fa-linkedin-in" style={{fontSize:'22px'}}></i>
//                       </a>
//                       <a
//                         href="#"
//                         className="social-icon instagram"
//                       >
//                         <i className="fab fa-instagram" style={{fontSize:'22px'}}></i>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//             </OwlCarousel>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testmonial;





















// import React, { useState } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import Modal from 'react-modal';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import { FaLinkedin } from 'react-icons/fa';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// Modal.setAppElement('#root');

// const Testimonial = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [activeTestimonial, setActiveTestimonial] = useState(null);

//   const testimonials = [
//     {
//       image: image1,
//       text: "As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications...",
//       name: "G. Lokesh",
//       designation: "Automation Training Specialist",
//       linkedin: "https://www.linkedin.com/in/md-ghouse",
//     },
//     {
//       image: image2,
//       text: "With 15 years of extensive experience in Tools and Fixture Design, I bring a wealth of knowledge to every training session...",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//       linkedin: "https://www.linkedin.com/in/saritha-komandla",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional processes...",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//       linkedin: "https://www.linkedin.com/in/thirumal-rao",
//     },
//   ];

//   const options = {
//     className: "owl-theme",
//     loop: true,
//     margin: 20,
//     nav: false,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     dots: false,
//     responsive: {
//       0: { items: 2 },
//       600: { items: 3 },
//       1000: { items: 4 },
//     },
//   };

//   const openModal = (testimonial) => {
//     setActiveTestimonial(testimonial);
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//     setActiveTestimonial(null);
//   };

//   return (
//     <div style={{ padding: '50px', textAlign: 'center' }}>
//       <h1 style={{ fontSize: '48px', fontWeight: 'bold', fontFamily: 'Roboto' }}>
//         <span style={{ color: 'black' }}>What Our </span>
//         <span style={{ color: 'orange' }}>Trainers Say</span>
//       </h1>

//       <OwlCarousel {...options}>
//         {testimonials.map((testimonial, index) => (
//           <div key={index} onClick={() => openModal()} style={{ cursor: 'pointer', padding: '10px' }}>
//             <img
//               src={testimonial.image}
//               alt={testimonial.name}
//               style={{
//                 width: '130px',
//                 height: '130px',
//                 borderRadius: '50%',
//                 border: '4px solid orange',
//                 objectFit: 'cover',
//                 margin: '0 auto',
//               }}
//             />
//             <h3 style={{ marginTop: '10px', fontSize: '16px', fontWeight: 'bold' }}>{testimonial.name}</h3>
//             <p style={{ fontSize: '14px', color: '#777' }}>{testimonial.designation}</p>
//           </div>
//         ))}
//       </OwlCarousel>

//       {activeTestimonial && (
//         <Modal
//           isOpen={modalIsOpen}
//           onRequestClose={closeModal}
//           contentLabel="Testimonial Details"
//           style={{
//             content: {
//               maxWidth: '600px',
//               margin: 'auto',
//               padding: '30px',
//               borderRadius: '10px',
//               textAlign: 'center',
//             },
//           }}
//         >
//           <img
//             src={activeTestimonial.image}
//             alt={activeTestimonial.name}
//             style={{
//               width: '100px',
//               height: '100px',
//               borderRadius: '50%',
//               border: '3px solid orange',
//               marginBottom: '20px',
//             }}
//           />
//           <h2>{activeTestimonial.name}</h2>
//           <h4 style={{ color: '#888' }}>{activeTestimonial.designation}</h4>
//           <p style={{ marginTop: '20px' }}>{activeTestimonial.text}</p>
//           <a href={activeTestimonial.linkedin} target="_blank" rel="noopener noreferrer">
//             <FaLinkedin style={{ color: '#0077b5', fontSize: '24px', marginTop: '10px' }} />
//           </a>
//           <br />
//           <button
//             onClick={closeModal}
//             style={{
//               marginTop: '20px',
//               padding: '10px 20px',
//               border: 'none',
//               backgroundColor: 'orange',
//               color: '#fff',
//               borderRadius: '5px',
//               cursor: 'pointer',
//             }}
//           >
//             Close
//           </button>
//         </Modal>
//       )}
//     </div>
//   );
// };

// export default Testimonial;



// import React, { useState } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// // Example React banner component to show in popup
// const Reactbanner = ({ trainer }) => {
//   return (
//     <div style={{ padding: 20, backgroundColor: '#fff', borderRadius: 10 }}>
//       <h2>{trainer.name}</h2>
//       <h4>{trainer.designation}</h4>
//       <p>{trainer.text}</p>
//       <img
//         src={trainer.image}
//         alt={trainer.name}
//         style={{ width: '200px', borderRadius: '10px', marginTop: 10 }}
//       />
//     </div>
//   );
// };

// const Testimonial = () => {
//   const [popupTrainer, setPopupTrainer] = useState(null);

//   const testimonials = [
//     {
//       image: image1,
//       text: "As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications...",
//       name: "G. Lokesh",
//       designation: "Automation Training Specialist",
//     },
//     {
//       image: image2,
//       text: "With 15 years of extensive experience in Tools and Fixture Design, I bring a wealth of knowledge to every training session...",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional processes...",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//     },
//   ];

//   const options = {
//     className: "owl-theme",
//     loop: true,
//     margin: 20,
//     nav: false,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     dots: false,
//     responsive: {
//       0: { items: 2 },
//       600: { items: 3 },
//       1000: { items: 4 },
//     },
//   };

//   const openPopup = (trainer) => {
//     setPopupTrainer(trainer);
//   };

//   const closePopup = () => {
//     setPopupTrainer(null);
//   };

//   return (
//     <div style={{ padding: '50px', textAlign: 'center' }}>
//       <h1 style={{ fontSize: '48px', fontWeight: 'bold', fontFamily: 'Roboto',marginTop:'-71px' }}>
//         <span style={{ color: 'black' }}> Our </span>
//         <span style={{ color: 'orange' }}>Speakers</span>
//       </h1>

//       <OwlCarousel {...options}>
//         {testimonials.map((testimonial, index) => (
//           <div
//             key={index}
//             onClick={() => openPopup(testimonial)}
//             style={{ cursor: 'pointer', padding: '10px' }}
//           >
//             <img
//               src={testimonial.image}
//               alt={testimonial.name}
//               style={{
//                 width: '130px',
//                 height: '130px',
//                 borderRadius: '50%',
//                 border: '4px solid orange',
//                 objectFit: 'cover',
//                 margin: '0 auto',
//               }}
//             />
//             <h3 style={{ marginTop: '10px', fontSize: '16px', fontWeight: 'bold' }}>{testimonial.name}</h3>
//             <p style={{ fontSize: '14px', color: '#777' }}>{testimonial.designation}</p>
//           </div>
//         ))}
//       </OwlCarousel>

//       {/* Popup overlay */}
//       {popupTrainer && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(0,0,0,0.6)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 9999,
//           }}
//           onClick={closePopup} // close if user clicks outside the popup box
//         >
//           <div
//             onClick={(e) => e.stopPropagation()} // prevent closing if clicking inside the popup
//             style={{
//               backgroundColor: 'white',
//               padding: 20,
//               borderRadius: 15,
//               maxWidth: '90%',
//               maxHeight: '90%',
//               overflowY: 'auto',
//               boxShadow: '0 0 20px rgba(0,0,0,0.25)',
//             }}
//           >
//             <button
//               onClick={closePopup}
//               style={{
//                 float: 'right',
//                 background: 'orange',
//                 border: 'none',
//                 color: 'white',
//                 padding: '5px 10px',
//                 borderRadius: '5px',
//                 cursor: 'pointer',
//                 marginBottom: 10,
//               }}
//             >
//               Close
//             </button>
//             <Reactbanner trainer={popupTrainer} />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Testimonial;



// import React, { useState } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLinkedin, faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';


// // React banner component - content left, image right
// const Reactbanner = ({ trainer }) => {
//   return (
//      <div
//       style={{
//         display: 'flex',
//         flexDirection: 'row',
//         gap: 20,
//         alignItems: 'center',
//         flexWrap: 'wrap',
//         maxWidth: '700px',
//       }}
//     >
//       <div style={{ flex: '1 1 300px', minWidth: 250 }}>
//         <h2 style={{
//           marginBottom: 10,
//           textAlign: 'left',
//           fontWeight: 'bold',
//           fontSize: '48px',
//           color: '#222'
//         }}>
//           {trainer.name}
//         </h2>

//         <h4 style={{
//           marginBottom: 15,
//           color: '#555',
//           textAlign: 'left',
//           fontWeight: '500',
//           fontSize: '35px'
//         }}>
//           {trainer.designation}
//         </h4>

//         <p style={{
//           fontSize: '16px',
//           lineHeight: '1.8',
//           color: '#333',
//           textAlign: 'left',
//           marginBottom: '20px'
//         }}>
//           {trainer.text}
//         </p>

//         {/* Social Media Icons */}
//         <div style={{ textAlign: 'center', marginTop: '20px' }}>
//           <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 15px', color: '#0e76a8', fontSize: '28px' }}>
//             <FontAwesomeIcon icon={faLinkedin} />
//           </a>
//           <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 15px', color: '#3b5998', fontSize: '28px' }}>
//             <FontAwesomeIcon icon={faFacebook} />
//           </a>
//           <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 15px', color: '#00acee', fontSize: '28px' }}>
//             <FontAwesomeIcon icon={faTwitter} />
//           </a>
//           <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" style={{ margin: '0 15px', color: '#C13584', fontSize: '28px' }}>
//             <FontAwesomeIcon icon={faInstagram} />
//           </a>
//         </div>
//       </div>


//       {/* Image Right */}
//       <div style={{ flex: '0 0 200px', textAlign: 'center' }}>
//         <img
//           src={trainer.image}
//           alt={trainer.name}
//           style={{
//             width: '200px',
//             height: 'auto',
//             borderRadius: '12px',
//             objectFit: 'cover',
//             boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// const Testimonial = () => {
//   const [popupTrainer, setPopupTrainer] = useState(null);

//   const testimonials = [
//     {
//       image: image1,
//       text: "As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications...",
//       name: "G. Lokesh",
//       designation: "Automation Training Specialist",
//     },
//     {
//       image: image2,
//       text: "With 15 years of extensive experience in Tools and Fixture Design, I bring a wealth of knowledge to every training session...",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional processes...",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//     },
//   ];

//   const options = {
//     className: 'owl-theme',
//     loop: true,
//     margin: 20,
//     nav: false,
//     autoplay: true,
//     autoplayTimeout: 3000,
//     autoplayHoverPause: true,
//     dots: false,
//     responsive: {
//       0: { items: 2 },
//       600: { items: 3 },
//       1000: { items: 4 },
//     },
//   };

//   const openPopup = (trainer) => setPopupTrainer(trainer);
//   const closePopup = () => setPopupTrainer(null);

//   return (
//     <div style={{ padding: '50px 20px', textAlign: 'center' }}>
//       <h1
//         style={{
//           fontSize: '48px',
//           fontWeight: 'bold',
//           fontFamily: 'Roboto',
//           // marginTop: '-71px',
//           marginBottom: '40px',
//         }}
//       >
//         <span style={{ color: 'black' }}> Our </span>
//         <span style={{ color: 'orange' }}>Speakers</span>
//       </h1>

//       <OwlCarousel {...options}>
//         {testimonials.map((testimonial, index) => (
//           <div
//             key={index}
//             onClick={() => openPopup(testimonial)}
//             style={{ cursor: 'pointer', padding: '10px' }}
//           >
//             <img
//               src={testimonial.image}
//               alt={testimonial.name}
//               style={{
//                 width: '130px',
//                 height: '130px',
//                 borderRadius: '50%',
//                 border: '4px solid orange',
//                 objectFit: 'cover',
//                 margin: '0 auto',
//                 display: 'block',
//               }}
//             />
//             <h3
//               style={{
//                 marginTop: '10px',
//                 fontSize: '16px',
//                 fontWeight: 'bold',
//                 color: '#333',
//               }}
//             >
//               {testimonial.name}
//             </h3>
//             <p style={{ fontSize: '14px', color: '#777' }}>{testimonial.designation}</p>
//           </div>
//         ))}
//       </OwlCarousel>

//       {/* Popup overlay */}
//       {popupTrainer && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(0,0,0,0.6)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 9999,
//             padding: 20,
//           }}
//           onClick={closePopup}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             style={{
//               backgroundColor: 'white',
//               padding: 30,
//               borderRadius: 15,
//               maxWidth: '54%',
//               maxHeight: '90%',
//               overflowY: 'auto',
//               boxShadow: '0 0 20px rgba(0,0,0,0.25)',
//               width: '100%',
//               boxSizing: 'border-box',
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <div style={{ width: '100%', position: 'relative' }}>
//               <button
//                 onClick={closePopup}
//                 style={{
//                   position: 'absolute',
//                   right: 0,
//                   top: 0,
//                   background: 'orange',
//                   border: 'none',
//                   color: 'white',
//                   padding: '6px 12px',
//                   borderRadius: '5px',
//                   cursor: 'pointer',
//                   fontWeight: 'bold',
//                   fontSize: '16px',
//                   zIndex: 10,
//                 }}
//                 aria-label="Close popup"
//               >
//                 ×
//               </button>

//               <Reactbanner trainer={popupTrainer} />
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Testimonial;




// import React, { useState, useEffect, useRef } from 'react';
// import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
//  import img3 from '../img/aaaservices/12_SARANYA.jpg';
// import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import { color } from 'framer-motion';

// const CoachProfiles = () => {
//   const [popupCoach, setPopupCoach] = useState(null);
//   const containerRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => setVisible(entry.isIntersecting),
//       { threshold: 0.2 }
//     );
//     if (containerRef.current) observer.observe(containerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   const coaches = [
//     {
//       name: 'G. Lokesh',
//       title: 'Automation Training Specialist',
//       image: img1,
//     },
//     {
//       name: 'Riyaz Uddin',
//       title: 'Subject Matter Expert',
//       image: img2,
//     },
//     {
//       name: 'SARANYA',
//       title: 'Automation Training Specialist',
//       image: img3,
//     },
//     {
//       name: 'MD. Ghouse',
//       title: 'Technical Trainer',
//       image: img4,
//     },
//   ];

//   return (
//     <div>
// <p style={{ textAlign: 'center', fontSize: '48px', fontWeight: 'bold', margin: '20px 0' }}>
//   <span style={{ color: 'rgb(0, 87, 200)' }}>Our </span>
//   <span style={{ color: 'rgb(255, 140, 0)' }}>Speakers</span>
// </p>



//     <div style={styles.section} ref={containerRef}>
//       <div
//         style={{
//           ...styles.grid,
//           ...(visible ? styles.slideIn : {}),
//         }}
//       >
//         {coaches.map((coach, i) => (
//           <div
//             key={i}
//             style={styles.card}
//             onClick={() => setPopupCoach(coach)}
//           >
//             <div style={styles.greenX} />
//             <img src={coach.image} alt={coach.name} style={styles.image} />
//             <h3 style={styles.name}>{coach.name}</h3>
//             <p style={styles.title}>{coach.title}</p>
//           </div>
//         ))}
//       </div>

//       {popupCoach && (
//         <div style={styles.overlay} onClick={() => setPopupCoach(null)}>
//           <div
//             style={styles.popupContent}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={styles.popupText}>
//               <h2>{popupCoach.name}</h2>
//               <p>{popupCoach.title}</p>
//               <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus imperdiet.</p>
//             </div>
//             <img
//               src={popupCoach.image}
//               alt={popupCoach.name}
//               style={styles.popupImage}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// };

// const styles = {
//   section: {
//     background: 'white',
//     color: '#fff',
//     // padding: '60px 20px',
//     textAlign: 'center',
//   },
//   grid: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'center',
//     gap: '40px',
//     opacity: 0,
//     transform: 'translateX(-100px)',
//     transition: 'all 0.8s ease',
//   },
//   slideIn: {
//     opacity: 1,
//     transform: 'translateX(0)',
//   },
//   card: {
//     position: 'relative',
//     background: 'white',
//     padding: '30px 20px',
//     borderRadius: '12px',
//     width: '320px',
//     textAlign: 'center',
//     cursor: 'pointer',
//     overflow: 'hidden',
//     transition: 'transform 0.3s ease',
//   },
//   greenX: {
//     position: 'absolute',
//     top: '10px',
//     left: '10px',
//     width: '100%',
//     height: '100%',
//     background: 'linear-gradient(135deg, transparent 10%,rgb(0, 87, 200) 10%,rgb(0, 80, 200) 70%, transparent 70%)',
//     opacity: 0.2,
//     zIndex: 0,
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     position: 'relative',
//     zIndex: 1,
//   },
//   name: {
//     color: 'orange',
//     marginTop: '10px',
//     zIndex: 1,
//     position: 'relative',
//   },
//   title: {
//     fontSize: '20px',
//     marginTop: '4px',
//     color:'blue',
//     fontWeight:'bold',
//     zIndex: 1,
//     position: 'relative',
//   },
//   overlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     background: 'rgba(0,0,0,0.85)',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     zIndex: 999,
//     animation: 'fadeIn 0.3s ease',
//   },
//   popupContent: {
//     background: 'blue',
//     color: 'white',
//     padding: '30px',
//     borderRadius: '10px',
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '20px',
//     maxWidth: '800px',
//     width: '90%',
//     animation: 'slideUp 0.4s ease',
//   },
//   popupImage: {
//     maxWidth: '300px',
//     borderRadius: '8px',
//     objectFit: 'cover',
//   },
//   popupText: {
//     flex: 1,
//     textAlign: 'left',
//   },
// };

// // Add animation styles to the page
// const styleSheet = document.styleSheets[0];
// const keyframesFade = `@keyframes fadeIn {
//   from { opacity: 0 }
//   to { opacity: 1 }
// }`;
// const keyframesSlide = `@keyframes slideUp {
//   from { transform: translateY(50px); opacity: 0 }
//   to { transform: translateY(0); opacity: 1 }
// }`;
// styleSheet.insertRule(keyframesFade, styleSheet.cssRules.length);
// styleSheet.insertRule(keyframesSlide, styleSheet.cssRules.length);

// export default CoachProfiles;





// import React, { useState, useEffect, useRef } from 'react';
// import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import img3 from '../img/aaaservices/12_SARANYA.jpg';
// import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

// const CoachProfiles = () => {
//   const containerRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => setVisible(entry.isIntersecting),
//       { threshold: 0.2 }
//     );
//     if (containerRef.current) observer.observe(containerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   const coaches = [
//     {
//       name: 'G. Lokesh',
//       title: 'Automation Training Specialist',
//       image: img1,
//     },
//     {
//       name: 'Riyaz Uddin',
//       title: 'Subject Matter Expert',
//       image: img2,
//     },
//     {
//       name: 'SARANYA',
//       title: 'Automation Training Specialist',
//       image: img3,
//     },
//     {
//       name: 'MD. Ghouse',
//       title: 'Technical Trainer',
//       image: img4,
//     },
//   ];

//   return (
//     <div>
//       <p style={{ textAlign: 'center', fontSize: '48px', fontWeight: 'bold', margin: '20px 0' }}>
//         <span style={{ color: 'rgb(0, 87, 200)' }}>Our </span>
//         <span style={{ color: 'rgb(255, 140, 0)' }}>Speakers</span>
//       </p>

//       <div style={styles.section} ref={containerRef}>
//         <div
//           style={{
//             ...styles.grid,
//             ...(visible ? styles.slideIn : {}),
//           }}
//         >
//           {coaches.map((coach, i) => (
//             <div key={i} style={styles.card}>
//               <div style={styles.greenX} />
//               <div className="flipContainer">
//                 <div className="flipInner">
//                   <div className="flipFront">
//                     <img src={coach.image} alt={coach.name} style={styles.image} />
//                   </div>
//                   <div className="flipBack">
//                     <h3 style={styles.name}>{coach.name}</h3>
//                     <p style={styles.title}>{coach.title}</p>
//                     <p style={{ fontSize: '14px', color: 'white' }}>
//                       Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <style>{`
//         .flipContainer {
//           width: 100%;
//           height: 320px;
//           perspective: 1000px;
//           position: relative;
//           z-index: 1;
//         }

//         .flipInner {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           transform-style: preserve-3d;
//           transition: transform 0.6s;
//         }

//         .flipContainer:hover .flipInner {
//           transform: rotateY(180deg);
//         }

//         .flipFront, .flipBack {
//           position: absolute;
//           width: 100%;
//           height: 100%;
//           backface-visibility: hidden;
//           border-radius: 8px;
//           overflow: hidden;
//         }

//         .flipFront {
//           z-index: 2;
//         }

//         .flipBack {
//           background: rgb(0, 87, 200);
//           color: white;
//           transform: rotateY(180deg);
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   section: {
//     background: 'white',
//     textAlign: 'center',
//   },
//   grid: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     justifyContent: 'center',
//     gap: '40px',
//     opacity: 0,
//     transform: 'translateX(-100px)',
//     transition: 'all 0.8s ease',
//   },
//   slideIn: {
//     opacity: 1,
//     transform: 'translateX(0)',
//   },
//   card: {
//     position: 'relative',
//     background: 'white',
//     padding: '30px 20px',
//     borderRadius: '12px',
//     width: '320px',
//     textAlign: 'center',
//     overflow: 'hidden',
//     cursor: 'pointer',
//   },
//   greenX: {
//     position: 'absolute',
//     top: '10px',
//     left: '10px',
//     width: '100%',
//     height: '100%',
//     background: 'linear-gradient(135deg, transparent 10%, rgb(0, 87, 200) 10%, rgb(0, 80, 200) 70%, transparent 70%)',
//     opacity: 0.2,
//     zIndex: 0,
//   },
//   image: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//   },
//   name: {
//     color: 'orange',
//     marginTop: '10px',
//     zIndex: 1,
//     position: 'relative',
//   },
//   title: {
//     fontSize: '20px',
//     marginTop: '4px',
//     color: 'white',
//     fontWeight: 'bold',
//     zIndex: 1,
//     position: 'relative',
//   },
// };

// export default CoachProfiles;








import React, { useState, useEffect, useRef } from 'react';
import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
import img3 from '../img/aaaservices/12_SARANYA.jpg';
import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

const CoachProfiles = () => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const coaches = [
  {
    name: 'G. Lokesh',
    title: 'Automation Training Specialist',
    discription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    image: img1,
    linkedin: 'https://www.linkedin.com/in/glokesh',
    twitter: 'https://twitter.com/glokesh'
  },
  {
    name: 'Riyaz Uddin',
    title: 'Subject Matter Expert',
    discription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    image: img2,
    linkedin: 'https://www.linkedin.com/in/riyazuddin',
    twitter: 'https://twitter.com/riyazuddin'
  },
  {
    name: 'SARANYA',
    title: 'Automation Training Specialist',
    discription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    image: img3,
    linkedin: 'https://www.linkedin.com/in/saranya',
    twitter: 'https://twitter.com/saranya'
  },
  {
    name: 'MD. Ghouse',
    title: 'Technical Trainer',
    discription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit...',
    image: img4,
    linkedin: 'https://www.linkedin.com/in/mdghouse',
    twitter: 'https://twitter.com/mdghouse'
  }
];


  return (
    <div style={{backgroundColor:'blue'}}>
      <p style={{ textAlign: 'center', fontSize: '48px', fontWeight: 'bold', margin: '0px 0', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif',marginTop:'-63px' }}>
        <span style={{ color: 'white' }}>Our </span>
        <span style={{ color: 'rgb(247 148 29)' }}>Speakers</span>
      </p>

      <div style={styles.section} ref={containerRef}>
        <div
          style={{
            ...styles.grid,
            ...(visible ? styles.slideIn : {}),
          }}
        >
          {coaches.map((coach, i) => (
            <div key={i} style={styles.card}>
              <div style={styles.greenX} />
              <div className="flipContainer">
                <div className="flipInner">
                  <div className="flipFront">
                    <img src={coach.image} alt={coach.name} style={styles.image} />
                    <div style={styles.overlayText}>
                      <h3 style={styles.name}>{coach.name}</h3>
                      <p style={styles.title}>{coach.title}</p>
                    </div>
                  </div>
                  <div className="flipBack">
                    <h3 style={styles.name}>{coach.name}</h3>
                    <p style={styles.titlename}>{coach.title}</p>
                    <p style={styles.discription}>{coach.discription}</p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '10px' }}>
      <a href={coach.linkedin} target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin" style={{ fontSize: '20px', color: '#0077B5' }}></i>
      </a>
      <a href={coach.twitter} target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter" style={{ fontSize: '20px', color: '#1DA1F2' }}></i>
      </a>
    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .flipContainer {
          width: 100%;
          height: 320px;
          perspective: 1000px;
          position: relative;
         
          z-index: 1;
        }

        .flipInner {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          transition: transform 0.6s;
        }

        .flipContainer:hover .flipInner {
          transform: rotateY(180deg);
        }

        .flipFront, .flipBack {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          border-radius: 8px;
          overflow: hidden;
        }

        .flipFront {
          z-index: 2;
        }
          
        .flipBack {
          background:white;
          color:blue;
          transform: rotateY(180deg);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
      `}</style>
    </div>
  );
};

const styles = {
  section: {
    background: 'white',
    textAlign: 'center',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '40px',
    opacity: 0,
    transform: 'translateX(-100px)',
    transition: 'all 0.8s ease',
     backgroundColor:'blue'
  },
  slideIn: {
    opacity: 1,
    transform: 'translateX(0)',
  },
  card: {
    position: 'relative',
    background: 'white',
    padding: '30px 20px',
    borderRadius: '12px',
    width: '320px',
    textAlign: 'center',
    overflow: 'hidden',
    cursor: 'pointer',
    backgroundColor:'blue'
  },
  greenX: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    // width: '100%',
    height: '100%',
    background:
      'linear-gradient(135deg, transparent 10%, rgb(0, 87, 200) 10%, rgb(0, 80, 200) 70%, transparent 70%)',
    opacity: 0.2,
    zIndex: 0,
  },
  image: {
    width: '100%',
    height: '117%',
    objectFit: 'cover',
  },
  overlayText: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    background: 'rgba(0, 0, 0, 0.6)',
    color: 'blue',
    padding: '10px',
    zIndex: 3,
  },
  name: {
    color: 'orange',
    margin: '0',
    zIndex: 1,
    fontSize: '18px',
  },
  title: {
    fontSize: '14px',
    margin: '2px 0 0 0',
    color: 'white',
    fontWeight: 'normal',
    zIndex: 1,
  },
  titlename: {
    fontSize: '14px',
    margin: '2px 0 0 0',
    color: 'orange',
    fontWeight: 'normal',
    zIndex: 1,
  },
  discription:{
 maxWidth: '600px',
  margin: '0 auto',
  fontSize: '16px',
  lineHeight: '1.6',
  color: 'blue',
  textAlign: 'justify',
  marginTop:'10px',
  padding: '20px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, sans-serif'
  }
};

export default CoachProfiles;
